import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, TextField } from "@material-ui/core";
import MemberList from "../Items/MemberList";
import AddActivity from "../Items/AddActivity";
import MainBox from "../Items/MainBox";
import ActivitesList from "../Items/ActivitesList";
import StepDesc from "../Items/StepDesc";
import MultipleSelectBox from "../Items/MultipleSelectBox";
const bth = [
  {
    index: 1,
    name: "دفاع مقدس",
  },
  {
    index: 2,
    name: "علمی و فناوری",
  },
  {
    index: 3,
    name: "اقتصادی",
  },
  {
    index: 4,
    name: "سیاست و حکومت داری",
  },
  {
    index: 5,
    name: "فرهنگی",
  },
  {
    index: 6,
    name: "اجتماعی",
  }, {
    index: 7,
    name: "روایت فتح",
  },
];
export default function HoldingENGH(props) {
  // console.log(props)
  return (
    <MainBox>
      <MemberList
        groupName={props.states.groupName}
        memberList={props.states.memberList}
      />

      <StepDesc>
        تو این مرحله قراره مدرسه انقلابتون رو معرفی کنید. چندتا غرفه داشتید؟
        موضوع غرفه هاتون چی بوده؟ عکس غرفه هاتون رو بزارید و برنامه هایی که تو
        غرفه ها داشتید رو برامون بارگذاری کنید. ما که خیلی دوس داریم مخصوصا
        اونجاهایی که شما خلاقیت به خرج دادید رو تماشا کنیم.
      </StepDesc>
      <div className="BoothSelectorArea">
        <div className={`flexRow BoothSelectorContainer`}>
          <label style={{ marginLeft: 50 }}>
            غرفه های موجود در نمایشگاه (چند انتخابی)
          </label>
          <MultipleSelectBox
            ids={props.booths}
            items={bth}
            setStateId={props.setBooths}
          />
        </div>
        {props.booths.length > 0 ? (
          <div style={{marginBottom: 35}}>
            <span style={{ fontSize: "1.2em" }}>
              انتخاب شده ها:{" "}
            </span>
            {props.booths?.map((e) => e.name).join("، ")}
          </div>
        ) : (
          ""
        )}
      </div>
      <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        ActivityCounts={props.ActivityCounts}
      />
      <ActivitesList
        step={4}
        activities={props.activities}
        stepActs={props.stepActs}
        refresh={props.refresh}
      />
    </MainBox>
  );
}
